import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PerfiladoComponent } from './perfilado/perfilado.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { MatTableModule } from '@angular/material/table';
import { UiSwitchModule } from 'ngx-ui-switch';
import { PropiedadesPerfilComponent } from './perfilado/propiedades-perfil/propiedades-perfil.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AsignacionFuncionesComponent } from './perfilado/asignacion-funciones/asignacion-funciones.component';
import { MatTreeModule } from '@angular/material/tree';
import { TreeViewComponent } from './perfilado/tree-view/tree-view.component';
import { MatSelectModule } from '@angular/material/select';
import { ModulosAsignadosComponent } from './perfilado/modulos-asignados/modulos-asignados.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { MatGridListModule } from '@angular/material/grid-list';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    AppComponent,
    PerfiladoComponent,
    PropiedadesPerfilComponent,
    AsignacionFuncionesComponent,
    TreeViewComponent,
    ModulosAsignadosComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatTableModule,
    NgxUiLoaderModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    MatMenuModule,
    MatTabsModule,
    MatTreeModule,
    MatSelectModule,
    MatGridListModule,
    Ng2SearchPipeModule,
    NgbDropdownModule,
    UiSwitchModule
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
